import PropTypes from "prop-types";
import styles from "./index.css";
import ProductStockBanner from "../ProductStockBanner";
import { SellingFastBadge } from "../SellingFastBadge";

const ProductTileBanners = ({ labels, ...rest }) => (
  <>
    <SellingFastBadge
      labelledById={labels.sellingFast}
      className={styles.sellingFastBadge}
      {...rest}
    />
    <ProductStockBanner
      className={styles.productStockBanner}
      labelledById={labels.stock}
      {...rest}
    />
  </>
);

ProductTileBanners.propTypes = {
  labels: PropTypes.shape({
    stock: PropTypes.string.isRequired,
    sellingFast: PropTypes.string.isRequired
  }).isRequired
};
export default ProductTileBanners;
